const mortgageRequestStates = require('./mortgageRequestStates');

module.exports = {
    CURRENT_STATES_DATA_PROPRIETOR: [
        mortgageRequestStates.APORTAR_DOC,
        mortgageRequestStates.AUT_CIRBE,
        mortgageRequestStates.CONFIRMA_DATOS_T2,
    ],
    APPROVED_STATES_DATA_PROPRIETOR: [
        mortgageRequestStates.AUT_CIRBE_CO,
        mortgageRequestStates.WAIT_CIRBE_COT,
        mortgageRequestStates.ERROR_BUREAUS,
        mortgageRequestStates.DATOS_VIV,
        mortgageRequestStates.TRAMITAR_NS,
        mortgageRequestStates.WAIT_NS,
        mortgageRequestStates.PROBLEMA_NS,
        mortgageRequestStates.PEND_TASACION,
        mortgageRequestStates.TRAMITAR_TAS,
        mortgageRequestStates.WAIT_DICTAMEN,
        mortgageRequestStates.ANALISIS_TAS,
        mortgageRequestStates.MODEL_CORRECT,
        mortgageRequestStates.APERTURA_CUENTA,
        mortgageRequestStates.ESPERA_AUTORIZACION_SEGURO_HOGAR,
        mortgageRequestStates.APROBADO_RIESGOS,
        mortgageRequestStates.GENERANDO_OV,
        mortgageRequestStates.PROV_FONDOS,
        mortgageRequestStates.ESPERA_DOC_FIRMA,
        mortgageRequestStates.ESPERA_ACTA_NOTARIO,
        mortgageRequestStates.GESTION_FECHA_FIRMA,
        mortgageRequestStates.PEND_MMPP,
        mortgageRequestStates.PEND_SALDO,
        mortgageRequestStates.PEND_FIRMA,
        mortgageRequestStates.FIRMADO,
        mortgageRequestStates.OFRECER_FINANCIACION_GASTOS
    ],
    CURRENT_STATES_LIVING_PLACE: [
        mortgageRequestStates.DATOS_VIV,
        mortgageRequestStates.TRAMITAR_NS,
        mortgageRequestStates.WAIT_NS,
        mortgageRequestStates.PROBLEMA_NS,
        mortgageRequestStates.PEND_TASACION,
        mortgageRequestStates.TRAMITAR_TAS,
        mortgageRequestStates.WAIT_DICTAMEN,
        mortgageRequestStates.ANALISIS_TAS,
        mortgageRequestStates.ESPERA_AUTORIZACION_SEGURO_HOGAR,
    ],
    NS_UPLOADED_OR_REQUESTED: [
        mortgageRequestStates.TRAMITAR_NS,
        mortgageRequestStates.WAIT_NS,
    ],
    NS_RESULT: [
        mortgageRequestStates.PEND_TASACION,
        mortgageRequestStates.TRAMITAR_TAS,
        mortgageRequestStates.WAIT_DICTAMEN,
        mortgageRequestStates.ANALISIS_TAS,
        mortgageRequestStates.MODEL_CORRECT,
        mortgageRequestStates.APERTURA_CUENTA,
        mortgageRequestStates.APROBADO_RIESGOS,
        mortgageRequestStates.PROV_FONDOS,
        mortgageRequestStates.ESPERA_DOC_FIRMA,
        mortgageRequestStates.ESPERA_ACTA_NOTARIO,
        mortgageRequestStates.GESTION_FECHA_FIRMA,
        mortgageRequestStates.PEND_MMPP,
        mortgageRequestStates.PEND_SALDO,
        mortgageRequestStates.PEND_FIRMA,
        mortgageRequestStates.FIRMADO,
        mortgageRequestStates.TASA_ESF_KO
    ],
    TAS_UPLOADED_OR_REQUESTED: [
        mortgageRequestStates.ANALISIS_TAS,
        mortgageRequestStates.MODEL_CORRECT,
        mortgageRequestStates.APROBADO_RIESGOS,
        mortgageRequestStates.PROV_FONDOS,
        mortgageRequestStates.ESPERA_DOC_FIRMA,
        mortgageRequestStates.ESPERA_ACTA_NOTARIO,
        mortgageRequestStates.GESTION_FECHA_FIRMA,
        mortgageRequestStates.PEND_MMPP,
        mortgageRequestStates.PEND_SALDO,
        mortgageRequestStates.PEND_FIRMA,
        mortgageRequestStates.FIRMADO,
        mortgageRequestStates.TASA_ESF_KO
    ],
    APPROVED_STATES_LIVING_PLACE: [
        mortgageRequestStates.MODEL_CORRECT,
        mortgageRequestStates.APERTURA_CUENTA,
        mortgageRequestStates.APROBADO_RIESGOS,
        mortgageRequestStates.GENERANDO_OV,
        mortgageRequestStates.PROV_FONDOS,
        mortgageRequestStates.ESPERA_DOC_FIRMA,
        mortgageRequestStates.ESPERA_ACTA_NOTARIO,
        mortgageRequestStates.GESTION_FECHA_FIRMA,
        mortgageRequestStates.PEND_MMPP,
        mortgageRequestStates.PEND_SALDO,
        mortgageRequestStates.PEND_FIRMA,
        mortgageRequestStates.FIRMADO,
        mortgageRequestStates.OFRECER_FINANCIACION_GASTOS,
        mortgageRequestStates.ESPERA_AUTORIZACION_SEGURO_HOGAR
    ],
    CURRENT_STATES_SIGNATURE: [
        mortgageRequestStates.APERTURA_CUENTA,
        mortgageRequestStates.APROBADO_RIESGOS,
        mortgageRequestStates.GENERANDO_OV,
        mortgageRequestStates.PROV_FONDOS,
        mortgageRequestStates.ESPERA_DOC_FIRMA,
        mortgageRequestStates.ESPERA_ACTA_NOTARIO,
        mortgageRequestStates.GESTION_FECHA_FIRMA,
        mortgageRequestStates.PEND_MMPP,
        mortgageRequestStates.PEND_SALDO,
        mortgageRequestStates.OFRECER_FINANCIACION_GASTOS
    ],
    APPROVED_STATES_SIGNATURE: [
        mortgageRequestStates.PEND_FIRMA,
        mortgageRequestStates.FIRMADO
    ]
};
